import VendorChargesService from '../VendorChargesService';
import VendorChargeSearch from "../VendorChargeSearch.model";
import {VENDOR_CHARGES_TABLE_NAME} from "@/modules/constants";
import {store} from "@/plugins/vuex";
import i18n from "@/shared/i18n";
import _ from "lodash";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: 'created_data',
    search: '',
    extraFilters: {},
    branch: {},
    searchModel: new VendorChargeSearch(),
    fields: getDefaultFields(),
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['name', 'is_active'],
      defaultFields: ['name', 'level', 'applies_to', 'calculate_from', 'is_aggregate', 'is_taxable', 'is_tax_inclusive',
        'is_active', 'tiers', 'tax_rate', 'created_data', 'lot_statuses'],
      dynamicFields: [],
    }
  }
};

let getDefaultFields = () => {
  return [
    {key: 'name', label: i18n.t('Name'), sortable: true, isVisible: true},
    {key: 'level', label: i18n.t('Level'), isVisible: true},
    {key: 'applies_to', label: i18n.t('Applies To'), isVisible: true},
    {key: 'lot_statuses', label: i18n.t('Lot Statuses'), isVisible: true, tdClass: 'lot-statuses-col'},
    {key: 'calculate_from', label: i18n.t('Calculate From'), isVisible: true, tdClass: 'calculate-from-col'},
    // {key: 'func_name', label: i18n.t('Function'), isVisible: true},
    {key: 'is_aggregate', label: i18n.t('Is Aggregate'), isVisible: true, tdClass: 'is-aggregate-col'},
    {key: 'is_taxable', label: i18n.t('Is Taxable'), isVisible: true, tdClass: 'is-taxable-col'},
    {key: 'is_tax_inclusive', label: i18n.t('Is Tax Inclusive'), isVisible: true, tdClass: 'is-tax-inclusive-col'},
    // {key: 'is_pay_upfront', label: i18n.t('Is Pay Upfront'), isVisible: true},
    // {key: 'is_exclude', label: i18n.t('Is Exclude'), isVisible: true},
    {key: 'is_active', label: i18n.t('Is Active'), isVisible: true, sortable: true, tdClass: 'is-active-col'},
    {key: 'tiers', label: i18n.t('Flat Price / %'), isVisible: true, exclude_from_export: true},
    {key: 'tax_rate', label: i18n.t('Tax Rate'), isVisible: true},
    {key: 'created_data', label: i18n.t('Created at / Created by'), isVisible: true, expand: 'created_by'}
  ]
}

export default {
  namespaced: true,
  name: 'vendorCharges',
  state: {
    tableSource: null,
    tableSourceUuid: null,
    tableData: {
      branch: getDefaultTableData(),
      customer: getDefaultTableData(),
      receipt: getDefaultTableData(),
      inventory: getDefaultTableData(),
      lot: getDefaultTableData()
    },
    vendorChargeModal: {
      object: null,
      show: false
    }
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new VendorChargeSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${VENDOR_CHARGES_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      data['source'] = state.tableSource;
      data['source_uuid'] = state.tableSourceUuid;

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await VendorChargesService.getVendorCharges(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const branch = state.tableData[state.tableSource].branch;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].branch = branch;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {source, sourceUuid}) {
      state.tableSource = source;
      state.tableSourceUuid = sourceUuid;
    },
    async updateTableData({commit}, payload) {
      commit('updateTableData', {rows: payload});
    },
    showVendorChargeModal({commit}, object = null) {
      commit('showVendorChargeModal', {object: _.cloneDeep(object)});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async deleteCharge({state, commit}, charge) {
      let response = await VendorChargesService.removeCharge(charge.uuid);
      if (response.success) {
        state.tableData[state.tableSource].rows = state.tableData[state.tableSource].rows.filter(c => c.uuid != charge.uuid);
      }
      return response;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {
      ...state.tableData[state.tableSource],
      ...payload
    },
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    showVendorChargeModal: (state, {object}) => {
      state.vendorChargeModal.object = object;
      state.vendorChargeModal.show = true;
    },
    hideModal: (state) => state.vendorChargeModal.show = false,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
